export default {
  seo: {
    home: {
      title: 'Artemida Studio — Soluzioni digitali creative',
      description:
        'Realizziamo siti web su misura di qualsiasi complessità: landing page, siti aziendali e assistenti IA.',
      keywords: 'sviluppo web, landing page, sito aziendale, IA',
    },
    // 🔽 nuovo: SEO per l’elenco del blog
    blog: {
      title: 'Blog — Artemida Studio',
      description:
        'Approfondimenti su sviluppo web, design, assistenti IA e creazione di siti web moderni per le aziende.',
      keywords: 'blog, sviluppo web, design, ia, siti web',
    },
  },

  header: {
    homeLink: 'Home',
    aboutUsLink: 'Chi Siamo',
    servicesLink: 'Servizi',
    ourProjectsLink: 'I nostri progetti',
    contact: 'Contatti',
    blogLink: 'Blog',
  },
  heroSection: {
    companyDescription:
      'Realizziamo siti web personalizzati di qualsiasi complessità',
    contactUs: 'Contattaci',
  },
  aboutUsSection: {
    aboutUsTitle: 'Chi Siamo',
    aboutUsDescription:
      'In Artemida Studio siamo specializzati nella creazione di landing page e siti corporate su misura che aiutano le aziende a costruire una forte presenza online. La nostra missione è offrire soluzioni moderne, funzionali e visivamente d’impatto, perfettamente allineate alle esigenze del tuo brand.\n\n' +
      'Unendo creatività, tecnologie all’avanguardia e un approccio personalizzato, realizziamo siti non solo belli esteticamente, ma anche veloci, intuitivi e completamente responsive.\n\n' +
      'Che tu abbia bisogno di una landing page ad alta conversione o di un sito aziendale professionale, Artemida Studio è qui per trasformare la tua visione in realtà con soluzioni su misura di alta qualità.\n\n' +
      'Scegli professionalità e creatività – costruiamo insieme il tuo sito perfetto!',
  },

  // Servizi (i18n керує всією секцією)
  services: {
    ourServices: 'I nostri servizi',
    servicesDescription:
      'Siamo specializzati nella creazione di soluzioni digitali personalizzate e di alta qualità per far crescere il tuo business',
    contactUs: 'Contattaci',
    items: [
      {
        key: 'landing',
        title: 'Landing \n Page',
        descriptionList: [
          'Una landing page ben progettata è uno strumento potente per attirare clienti, aumentare le conversioni e rafforzare la presenza online del tuo brand. In Artemida Studio realizziamo landing page personalizzate di alta qualità, in linea con i tuoi obiettivi di business.',
          '✔️ Design moderno e unico – Pagine visivamente d’impatto, coerenti con il tuo brand.',
          '✔️ Alta capacità di conversione – Layout ottimizzati e CTA efficaci per aumentare l’engagement.',
          '✔️ Veloci e responsive – Prestazioni fulminee ed esperienza fluida su tutti i dispositivi.',
          '✔️ Pronte per SEO e marketing – Realizzate secondo le best practice per migliorare la visibilità e il traffico organico.',
          '✔️ Completamente personalizzabili – Ogni dettaglio è adattato alle tue esigenze e all’identità del brand.',
        ],
      },
      {
        key: 'corporate',
        title: 'Sito \n aziendale',
        descriptionList: [
          'Un sito aziendale professionale è essenziale per costruire credibilità, valorizzare il brand e coinvolgere i clienti. In Artemida Studio sviluppiamo siti aziendali su misura che riflettono i valori della tua azienda e ti distinguono nel mondo digitale.',
          '✔️ Design professionale e unico – Stile pulito e moderno, in linea con l’identità del tuo brand.',
          '✔️ Completamente personalizzabile – Ogni elemento progettato sui tuoi obiettivi e bisogni.',
          '✔️ Veloce e sicuro – Ottimizzato per velocità, sicurezza e prestazioni impeccabili.',
          '✔️ SEO & marketing friendly – Sviluppato secondo le best practice per aumentare la visibilità e attrarre nuovi clienti.',
          '✔️ Mobile e user-friendly – Design totalmente responsive per un’esperienza perfetta su ogni dispositivo.',
          '✔️ Gestione contenuti semplice – Aggiornamenti rapidi con un CMS intuitivo.',
        ],
      },
      {
        key: 'ai',
        title: 'Integrazione di assistenti IA',
        descriptionList: [
          'Potenzia il tuo sito con l’IA! In Artemida Studio integriamo assistenti basati su IA che migliorano l’esperienza utente, automatizzano i processi e aumentano il coinvolgimento. Che ti serva un chatbot intelligente, un supporto automatico o raccomandazioni guidate dall’IA, costruiamo soluzioni su misura per il tuo business.',
          '✔️ Assistenza clienti 24/7 – Chatbot basati su IA gestiscono le richieste in qualsiasi momento, aumentando la soddisfazione.',
          '✔️ Integrazione senza interruzioni – Funziona in modo fluido all’interno del tuo sito, migliorandone le funzionalità.',
          '✔️ Esperienza utente personalizzata – Interazioni guidate dall’IA, adattate a bisogni e preferenze.',
          '✔️ Lead generation e vendite – Coinvolgi i visitatori, raccogli contatti e guida gli utenti all’acquisto.',
          '✔️ Automazione ed efficienza – Snellisci i processi riducendo carichi di lavoro e tempi di risposta.',
          '✔️ Soluzioni IA personalizzate – Completamente adattabili al tuo modello di business e ai requisiti specifici.',
        ],
      },
    ],
  },
  contactSection: {
    title: 'Parliamo del tuo progetto',
    placeholderName: 'Nome',
    placeholderPhone: 'Telefono',
    placeholderEmail: 'Email',
    placeholderMessage: 'Raccontaci del tuo progetto',
    sendButton: 'Invia',
  },
};
